module.exports = __webpack_public_path__ + "static/media/iphone-network.6527c964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iphone-network.png
// module id = 747
// module chunks = 2